export var Resident;
(function (Resident) {
    let type;
    (function (type) {
        type["RESIDENT"] = "Resident";
    })(type = Resident.type || (Resident.type = {}));
})(Resident || (Resident = {}));
